export /* istanbul ignore next: boilerplate code */ default function getAuth0LogoutURL() {
  return `https://${process.env.AUTH0_DOMAIN}/v2/logout?client_id=${process.env.AUTH0_CLIENTID}&returnTo=${process.env.SIGNOUT_URL}`;
}
